import type { User } from '@api/types';

const isUserRoleDeveloper = (user: User) => {
  return user.role === 'ROLE_DEVELOPER';
};

export { isUserRoleDeveloper };
